import { css } from "@emotion/react";

export const labelStyles = ({ theme, darkBackground }) => css`
    color: ${darkBackground
        ? theme.colors.typography.defaultDarkBackground
        : theme.colors.typography.defaultLightBackground};
    display: block;
    font-weight: 700;
    padding-bottom: 10px;
`;
